<template>
  <hr
    class="divider-line"
    :class="[color, orientation, dividerType]"
    :orientation="orientation"
    :color="color"
  />
</template>

<script setup lang="ts">
export type Orientation = 'horizontal' | 'vertical';
export type Color = 'gray' | 'light-gray' | 'fun-blue';
export type DividerType = 'standard' | 'bold';

export interface LayoutDividerLineProps {
  orientation?: Orientation;
  color: Color;
  dividerType?: DividerType;
}

withDefaults(defineProps<LayoutDividerLineProps>(), {
  orientation: 'horizontal',
  dividerType: 'standard',
});
</script>

<style scoped lang="scss">
@use 'sass:map';
@use '../../assets/styles/colors' as colors;

.divider-line {
  border: 0;
  margin: 0;
  width: 100%;

  &.gray {
    background-color: map.get(colors.$colors, 'dusty-gray');
  }

  &.light-gray {
    background-color: map.get(colors.$colors, 'silver');
  }

  &.fun-blue {
    background-color: map.get(colors.$colors, 'fun-blue');
  }

  &.vertical {
    display: inline;
    height: 100%;
    position: absolute;
    width: 1px;
  }

  &.horizontal {
    &.standard {
      height: 1px;
    }

    &.bold {
      height: 2px;
    }
  }
}
</style>
